/** English, keyed by the Slovak text (see i18n/index.ts). */
export const en: Record<string, string> = {
  'Platnosť prihlásenia vypršala, prihláste sa prosím znova': 'Your session has expired, please sign in again',
  'Pneumatiky: {label}': 'Tyres: {label}',
  'Pneumatiky nezadané': 'Tyres not entered',
  'ŠPZ': 'Licence plate',
  'Značka': 'Make',
  'Model': 'Model',
  'Rok výroby': 'Year of manufacture',
  'VIN': 'VIN',
  'Palivo': 'Fuel',
  'Stav': 'Status',
  'Stav km': 'Mileage',
  'Poznámky': 'Notes',
  'Vytvoril (ID)': 'Created by (ID)',
  'Meno': 'First name',
  'Priezvisko': 'Last name',
  'Osobné číslo': 'Employee number',
  'Oddelenie': 'Department',
  'Telefón': 'Phone',
  'E-mail': 'E-mail',
  'Číslo VP': 'Licence number',
  'Platnosť VP': 'Licence valid until',
  'Aktívne': 'Active',
  'Vozidlo (ID)': 'Car (ID)',
  'Vodič (ID)': 'Driver (ID)',
  'Pridelené': 'Assigned',
  'Vrátené': 'Returned',
  'Počiatočné km': 'Starting km',
  'Konečné km': 'Final km',
  'Účel': 'Purpose',
  'Dátum servisu': 'Service date',
  'Typ servisu': 'Service type',
  'Popis': 'Description',
  'Km pri servise': 'Km at service',
  'Cena': 'Price',
  'Servis': 'Workshop',
  'Faktúra': 'Invoice',
  'Ďalší servis': 'Next service',
  'Ďalší servis (km)': 'Next service (km)',
  'Názov': 'Title',
  'Typ dokumentu': 'Document type',
  'Súbor': 'File',
  'Názov súboru': 'File name',
  'Typ súboru': 'File type',
  'Veľkosť': 'Size',
  'Nahral (ID)': 'Uploaded by (ID)',
  'Nahrané': 'Uploaded',
  'Platnosť do': 'Valid until',
  'Používateľ': 'User',
  'Celé meno': 'Full name',
  'Rola': 'Role',
  'Posledné prihlásenie': 'Last sign-in',
  'Názov spoločnosti': 'Company name',
  'Hlavná farba': 'Primary colour',
  'Doplnková farba': 'Secondary colour',
  'Logo': 'Logo',
  'Logo (tmavé)': 'Logo (dark)',
  'Žiadne zmeny': 'No changes',
  'Systém': 'System',
  'Dátum': 'Date',
  'Vozidlo': 'Car',
  'Typ': 'Type',
  'Km': 'Km',
  'Akcie': 'Actions',
  'Upraviť': 'Edit',
  'Zmazať': 'Delete',
  'Zmazať dokument': 'Delete document',
  'Naozaj zmazať dokument {title}? Súbor bude natrvalo odstránený.': 'Really delete the document {title}? The file will be removed permanently.',
  'Dokument bol zmazaný': 'The document was deleted',
  'Zobraziť': 'View',
  'Stiahnuť': 'Download',
  'Vodič': 'Driver',
  'Trasa': 'Route',
  'Vzdialenosť': 'Distance',
  'Doba': 'Duration',
  'Mesiac': 'Month',
  'Najazdené': 'Driven',
  '{count} jázd': '{count} rides',
  ' · súkr. {privateKm}': ' · private {privateKm}',
  'Tachometer': 'Odometer',
  'Navštívené miesta': 'Places visited',
  'Zmazať mesiac': 'Delete month',
  'Vozidlo bolo pridelené': 'The car was assigned',
  'Pridelenie sa nepodarilo vytvoriť': 'The assignment could not be created',
  'Prideliť vozidlo': 'Assign car',
  'Prideliť je možné iba aktívne vozidlo, ktoré práve nikto nemá.': 'Only an active car that nobody currently has can be assigned.',
  'Zrušiť': 'Cancel',
  'Prideliť': 'Assign',
  'Vyberte vozidlo': 'Choose a car',
  'Vyberte vodiča': 'Choose a driver',
  'Dátum a čas prevzatia': 'Pick-up date and time',
  'Počiatočný stav km': 'Starting mileage',
  'Aktuálne v evidencii: {currentKm} km': 'Currently recorded: {currentKm} km',
  'napr. služobné auto, cesta do Košíc': 'e.g. company car, trip to Košice',
  'Pridelenie bolo ukončené': 'The assignment was ended',
  'Pridelenie sa nepodarilo ukončiť': 'The assignment could not be ended',
  'Vrátenie vozidla': 'Return of the car',
  'Ukončiť pridelenie': 'End assignment',
  'Dátum a čas vrátenia': 'Return date and time',
  'Konečný stav km': 'Final mileage',
  'Počiatočný stav: {startKm} km': 'Starting mileage: {startKm} km',
  'Nesmie byť nižší ako počiatočný stav': 'Must not be lower than the starting mileage',
  'Poznámka k vráteniu': 'Return note',
  'napr. poškodenie, stav paliva': 'e.g. damage, fuel level',
  'Vozidlo bolo uložené': 'The car was saved',
  'Vozidlo bolo vytvorené': 'The car was created',
  'Vozidlo sa nepodarilo uložiť': 'The car could not be saved',
  'Upraviť vozidlo {plate}': 'Edit car {plate}',
  'Nové vozidlo': 'New car',
  'Uložiť': 'Save',
  'Vytvoriť': 'Create',
  'BA-123AB': 'BA-123AB',
  'ŠPZ je povinná': 'Licence plate is required',
  'Max. 20 znakov': 'Max. 20 characters',
  'Škoda': 'Škoda',
  'Značka je povinná': 'Make is required',
  'Octavia': 'Octavia',
  'Model je povinný': 'Model is required',
  'Neplatný rok': 'Invalid year',
  'Stav tachometra (km)': 'Odometer reading (km)',
  'Nesmie byť záporné': 'Must not be negative',
  'Zmluva {number} bola vygenerovaná': 'Contract {number} was generated',
  'Zmluvu sa nepodarilo vygenerovať': 'The contract could not be generated',
  'Generovať zmluvu': 'Generate contract',
  'Zmluva o nájme sa vyplní údajmi pracovníka a vozidla a stiahne sa ako dokument Word. Vozidlo sa zároveň pridelí pracovníkovi (Pridelenie).': 'The rental contract is filled in with the worker\'s and car\'s details and downloaded as a Word document. The car is also assigned to the worker (Assignments).',
  'Generovať': 'Generate',
  'Pracovník': 'Worker',
  'Vyberte pracovníka': 'Choose a worker',
  'Od': 'From',
  'Zadajte dátum': 'Enter a date',
  'Do': 'To',
  'Dátum „do“ nesmie byť skôr ako „od“': 'The “to” date must not be before the “from” date',
  'Cena za deň (€ bez DPH)': 'Price per day (€ excl. VAT)',
  'nevyplnené – doplní sa ručne': 'not filled in – to be completed by hand',
  'Spolu za {days} deň: {total} bez DPH': 'Total for {days} day: {total} excl. VAT',
  'Cena nesmie byť záporná': 'The price must not be negative',
  '{rejected} súbor(ov) nie je možné nahrať – nepodporovaný typ alebo väčší ako 50 MB': '{rejected} file(s) cannot be uploaded – unsupported type or larger than 50 MB',
  'Vyberte aspoň jeden súbor': 'Choose at least one file',
  'Dokument bol nahraný': 'The document was uploaded',
  'Nahraných {uploaded} dokumentov': '{uploaded} documents uploaded',
  'Nahrávanie zlyhalo': 'Upload failed',
  ' (nahraných {uploaded} z {files})': ' ({uploaded} of {files} uploaded)',
  'Nahrať dokumenty': 'Upload documents',
  'Nahrávanie {progress} %': 'Uploading {progress} %',
  'Nahrať': 'Upload',
  'Pustite súbory sem': 'Drop the files here',
  'Pretiahnite súbory sem alebo kliknite pre výber': 'Drag files here or click to choose',
  'PDF, obrázky, Word, Excel · max. 50 MB': 'PDF, images, Word, Excel · max. 50 MB',
  'Odobrať {name}': 'Remove {name}',
  'Použije sa názov súboru': 'The file name will be used',
  'Predvolene: názov súboru': 'Default: file name',
  'Upozornenie 30 dní pred koncom platnosti': 'Reminder 30 days before expiry',
  'Dokument bol uložený': 'The document was saved',
  'Dokument sa nepodarilo uložiť': 'The document could not be saved',
  'Upraviť dokument': 'Edit document',
  'Zadajte názov': 'Enter a title',
  'Vodič bol uložený': 'The driver was saved',
  'Vodič bol vytvorený': 'The driver was created',
  'Vodiča sa nepodarilo uložiť': 'The driver could not be saved',
  'Upraviť vodiča {firstName} {lastName}': 'Edit driver {firstName} {lastName}',
  'Nový vodič': 'New driver',
  'Meno je povinné': 'First name is required',
  'Priezvisko je povinné': 'Last name is required',
  'Neplatný e-mail': 'Invalid e-mail',
  'Číslo vodičského preukazu': 'Driving licence number',
  'Platnosť vodičského preukazu': 'Driving licence valid until',
  'Údaje pre zmluvy': 'Contract details',
  'Použijú sa pri generovaní zmlúv. Nevyplnené údaje zostanú v zmluve vybodkované na ručné doplnenie.': 'Used when generating contracts. Details left empty stay dotted in the contract to be filled in by hand.',
  'Dátum narodenia': 'Date of birth',
  'Typ pracovného vzťahu': 'Employment type',
  'Nevyplnené': 'Not filled in',
  'Adresa trvalého pobytu': 'Permanent address',
  'Ulica a číslo, PSČ Obec': 'Street and number, postcode town',
  'IČO': 'Company ID (IČO)',
  'DIČ': 'Tax ID (DIČ)',
  'Aktívny vodič': 'Active driver',
  'Vyberte vozidlo…': 'Choose a car…',
  'Načítava sa…': 'Loading…',
  'Vyberte vodiča…': 'Choose a driver…',
  'Pokuta bola uložená': 'The fine was saved',
  'Pokuta bola pridaná': 'The fine was added',
  'Pokutu sa nepodarilo uložiť': 'The fine could not be saved',
  'Upraviť pokutu': 'Edit fine',
  'Nová pokuta': 'New fine',
  'Pridať': 'Add',
  'Krajina': 'Country',
  'Dátum priestupku': 'Date of offence',
  'Suma (€)': 'Amount (€)',
  'Zadajte sumu': 'Enter the amount',
  'Nesmie byť záporná': 'Must not be negative',
  'Kto dostal pokutu': 'Who got the fine',
  'Neurčený / zatiaľ nevieme': 'Unknown / not known yet',
  'Meno a priezvisko': 'First and last name',
  'Priestupok / dôvod': 'Offence / reason',
  'napr. prekročenie rýchlosti, parkovanie': 'e.g. speeding, parking',
  'Číslo pokuty / spisu': 'Fine / case number',
  'Zaplatená': 'Paid',
  'Dátum úhrady': 'Payment date',
  'Prázdne = dnes': 'Empty = today',
  'Hradil(a)': 'Paid by',
  'Firma': 'Company',
  'Vodič (zrazené / refakturované)': 'Driver (deducted / re-invoiced)',
  'Poznámka': 'Note',
  'Pracovník zo zoznamu alebo iné meno': 'Worker from the list or another name',
  'Zo zoznamu pracovníkov': 'From the worker list',
  'Iné meno (napísať)': 'Other name (type in)',
  'Rezervácia bola uložená': 'The reservation was saved',
  'Vozidlo bolo rezervované': 'The car was reserved',
  'Rezerváciu sa nepodarilo uložiť': 'The reservation could not be saved',
  'Upraviť rezerváciu': 'Edit reservation',
  'Rezervovať vozidlo': 'Reserve a car',
  'Rezervácia je na celé dni. Vozidlo sa pracovníkovi odovzdá neskôr – so zmluvou alebo interne.': 'The reservation covers whole days. The car is handed over to the worker later – with a contract or internally.',
  'Rezervovať': 'Reserve',
  'Pre koho': 'For whom',
  'Vyberte zamestnanca alebo živnostníka…': 'Choose an employee or self-employed worker…',
  'Pri odovzdaní vozidla sa osoba pridá do zoznamu vodičov.': 'When the car is handed over, the person is added to the list of drivers.',
  'Zadajte meno': 'Enter a name',
  'Účel / dôvod': 'Purpose / reason',
  'napr. služobná cesta Viedeň, stavba Žilina…': 'e.g. business trip to Vienna, building site Žilina…',
  'Servisný záznam bol uložený': 'The service record was saved',
  'Servisný záznam bol vytvorený': 'The service record was created',
  'Servisný záznam sa nepodarilo uložiť': 'The service record could not be saved',
  'Upraviť servisný záznam': 'Edit service record',
  'Nový servisný záznam': 'New service record',
  'Popis prác': 'Work done',
  'Stav km pri servise': 'Mileage at service',
  'Cena (€)': 'Price (€)',
  'Servis / dielňa': 'Workshop / garage',
  'Číslo faktúry': 'Invoice number',
  'Plán ďalšej údržby': 'Next maintenance plan',
  'Ďalší servis – dátum': 'Next service – date',
  'Ďalší servis – pri stave km': 'Next service – at mileage',
  'Pneumatiky {plate} boli uložené': 'Tyres of {plate} were saved',
  'Pneumatiky sa nepodarilo uložiť': 'The tyres could not be saved',
  'Aktuálne namontovaná sada. Pri prezutí ju prepíšte – predchádzajúca zostane v histórii zmien vozidla.': 'The set currently fitted. Overwrite it when the tyres are changed – the previous set stays in the car\'s change history.',
  'Typ pneumatík': 'Tyre type',
  'Nezadané': 'Not entered',
  'Namontované dňa': 'Fitted on',
  'napr. Michelin': 'e.g. Michelin',
  'Model / dezén': 'Model / tread',
  'napr. Alpin 6': 'e.g. Alpin 6',
  'Rozmer': 'Size',
  'napr. 205/55 R16 91H': 'e.g. 205/55 R16 91H',
  'Známka bola uložená': 'The vignette was saved',
  'Známka bola pridaná': 'The vignette was added',
  'Známku sa nepodarilo uložiť': 'The vignette could not be saved',
  'Upraviť diaľničnú známku': 'Edit motorway vignette',
  'Nová diaľničná známka': 'New motorway vignette',
  'Typ známky': 'Vignette type',
  'Platná od': 'Valid from',
  'Platná do': 'Valid to',
  'Doplní sa podľa typu – skontrolujte podľa dokladu o kúpe': 'Filled in from the type – check against the purchase receipt',
  'Nesmie byť skôr ako „platná od“': 'Must not be before “valid from”',
  'Číslo dokladu / referencia': 'Receipt number / reference',
  'Evidencia vozidiel': 'Fleet register',
  'Pripájanie…': 'Connecting…',
  'Živé aktualizácie zapnuté': 'Live updates on',
  'Živé aktualizácie nedostupné – údaje sa obnovia pri ďalšej akcii': 'Live updates unavailable – data will refresh with your next action',
  'Otvoriť menu': 'Open menu',
  'Administrátor': 'Administrator',
  'Môj účet a heslo': 'My account and password',
  'Odhlásiť sa': 'Sign out',
  'Jazyk': 'Language',
  'Boli ste odhlásení': 'You have been signed out',
  'Preskočiť na obsah': 'Skip to content',
  'Prehľad': 'Overview',
  'Vozidlá': 'Cars',
  'Vodiči': 'Drivers',
  'Rezervácie': 'Reservations',
  'Pridelenie': 'Assignments',
  'Zmluvy': 'Contracts',
  'Plán údržby': 'Maintenance plan',
  'Servisy': 'Services',
  'Pneumatiky': 'Tyres',
  'Diaľničné známky': 'Motorway vignettes',
  'Pokuty': 'Fines',
  'Dokumenty': 'Documents',
  'GPS jazdy': 'GPS rides',
  'Audit log': 'Audit log',
  'Nastavenia': 'Settings',
  'Zavrieť menu': 'Close menu',
  'Hlavná navigácia': 'Main navigation',
  'Administrácia': 'Administration',
  'Neplatné pred {days} dňami': 'Expired {days} days ago',
  'O {days} dní': 'In {days} days',
  'Žiadne záznamy': 'No records',
  '{from}–{to} z {total}': '{from}–{to} of {total}',
  'Počet záznamov na stránku': 'Records per page',
  '{size} / stránka': '{size} / page',
  'Predchádzajúca strana': 'Previous page',
  'Ďalšia strana': 'Next page',
  'Hľadať…': 'Search…',
  'Vymazať hľadanie': 'Clear search',
  'Zavrieť': 'Close',
  'Potvrdiť': 'Confirm',
  'Heslo bolo zmenené': 'The password was changed',
  'Heslo sa nepodarilo zmeniť': 'The password could not be changed',
  'Môj účet': 'My account',
  'Profil': 'Profile',
  'Používateľské meno': 'Username',
  'Zmena hesla': 'Change password',
  'Súčasné heslo': 'Current password',
  'Zadajte súčasné heslo': 'Enter your current password',
  'Nové heslo': 'New password',
  'Zadajte nové heslo': 'Enter a new password',
  'Aspoň 8 znakov': 'At least 8 characters',
  'Nové heslo znova': 'New password again',
  'Heslá sa nezhodujú': 'The passwords do not match',
  'Zmeniť heslo': 'Change password',
  'Nastavenie upozornení bolo uložené': 'Notification settings were saved',
  'E-mailová adresa bola odstránená – upozornenia nebudú chodiť': 'The e-mail address was removed – no notifications will be sent',
  'Nastavenie sa nepodarilo uložiť': 'The settings could not be saved',
  'Skúšobný e-mail sa nepodarilo odoslať': 'The test e-mail could not be sent',
  'Upozornenia e-mailom': 'E-mail notifications',
  'Upozornenie príde hneď, ako nastane – udalosti okamžite, blížiace sa termíny raz (kontrola každú hodinu cez deň).': 'A notification arrives as soon as something happens – events immediately, upcoming deadlines once (checked every hour during the day).',
  'Server zatiaľ nemá nastavené odosielanie e-mailov (SMTP v súbore backend\\.env). Nastavenie si môžete uložiť, e-maily začnú chodiť po jeho doplnení.': 'The server does not have e-mail sending set up yet (SMTP in backend\\.env). You can save your settings; e-mails will start arriving once it is set up.',
  'E-mailová adresa': 'E-mail address',
  'meno@firma.sk': 'name@company.com',
  'Zadajte platnú e-mailovú adresu': 'Enter a valid e-mail address',
  'Chcem dostávať': 'I want to receive',
  'Poslať skúšobný e-mail': 'Send test e-mail',
  'Prevzaté': 'Picked up',
  'Požičané': 'On loan',
  'Km (začiatok → koniec)': 'Km (start → end)',
  'Vrátiť': 'Return',
  'Pridelenie vozidiel': 'Car assignments',
  'Kto má ktoré vozidlo a história výpožičiek': 'Who has which car, and loan history',
  'Všetko': 'All',
  'Iba požičané': 'On loan only',
  'Všetky vozidlá': 'All cars',
  'Všetci vodiči': 'All drivers',
  'Žiadne pridelenia nezodpovedajú filtru': 'No assignments match the filter',
  'Čas': 'Time',
  'Akcia': 'Action',
  'Záznam': 'Record',
  'Zmena': 'Change',
  'Počítač / IP / MAC': 'Computer / IP / MAC',
  'Zobraziť všetky zmeny z tohto zariadenia': 'Show all changes from this device',
  'Použité účty': 'Accounts used',
  'len neúspešné prihlásenia': 'failed sign-ins only',
  'Záznamov': 'Records',
  'Prvý záznam': 'First record',
  'Posledný záznam': 'Last record',
  'Zmeny': 'Changes',
  'Kto, kedy, z ktorého počítača a čo zmenil – na úrovni jednotlivých polí': 'Who changed what, when and from which computer – field by field',
  'Export do CSV': 'Export to CSV',
  'Zariadenia': 'Devices',
  'Počítač, IP alebo MAC adresa…': 'Computer, IP or MAC address…',
  'Všetci': 'All',
  'Oblasť': 'Area',
  'Všetky': 'All',
  'ID záznamu': 'Record ID',
  'Pole': 'Field',
  'napr. current_km': 'e.g. current_km',
  'Počítače, z ktorých sa v systéme niečo robilo. Zvýraznené sú zariadenia, z ktorých sa prihlásilo viac účtov. MAC adresu server zistí len pri počítačoch v tej istej sieti (VLAN) ako server.': 'Computers from which anything was done in the system. Devices from which several accounts signed in are highlighted. The server can only find the MAC address of computers on the same network (VLAN) as the server.',
  'Žiadne zariadenia nezodpovedajú filtru': 'No devices match the filter',
  'Žiadne záznamy nezodpovedajú filtru': 'No records match the filter',
  'Detail zmeny': 'Change detail',
  'Zariadenie': 'Device',
  'IP adresa': 'IP address',
  'Názov počítača': 'Computer name',
  'MAC adresa': 'MAC address',
  'nezistená': 'not detected',
  'Odtlačok prehliadača': 'Browser fingerprint',
  'Pôvodná hodnota': 'Old value',
  'Nová hodnota': 'New value',
  'Vozidlo sa nenašlo': 'Car not found',
  'Späť na zoznam vozidiel': 'Back to the car list',
  'Vozidlo bolo vyradené z prevádzky': 'The car was taken out of service',
  'Vyradiť': 'Retire',
  'História zmien': 'Change history',
  'Vyradiť vozidlo': 'Retire car',
  'Vozidlo {plate} bude označené ako vyradené. História (servisy, dokumenty, jazdy) zostane zachovaná a stav je možné neskôr zmeniť úpravou vozidla.': 'Car {plate} will be marked as retired. Its history (services, documents, rides) is kept and the status can be changed later by editing the car.',
  'Aktuálne pridelenie': 'Current assignment',
  'Vrátiť vozidlo': 'Return car',
  'Prideliť vodičovi': 'Assign to a driver',
  'Vozidlo je voľné.': 'The car is available.',
  'Vozidlo nie je v aktívnej prevádzke, nie je možné ho prideliť.': 'The car is not in active service and cannot be assigned.',
  'Údaje o vozidle': 'Car details',
  'Značka a model': 'Make and model',
  'Stav tachometra': 'Odometer',
  'nezadané': 'not entered',
  'Posledná zmena': 'Last change',
  'Súhrn': 'Summary',
  'Náklady na servis spolu': 'Total service costs',
  'Najazdené podľa GPS': 'Driven according to GPS',
  'Posledný servis': 'Last service',
  'bez uvedenia servisu': 'no workshop given',
  'Poznámku sa nepodarilo uložiť': 'The note could not be saved',
  'Ukladá sa…': 'Saving…',
  'Uložené': 'Saved',
  'Chyba pri ukladaní': 'Error while saving',
  'Poznámky k vozidlu sa ukladajú automaticky…': 'Notes about the car are saved automatically…',
  'Poznámky k vozidlu': 'Notes about the car',
  'História pridelení': 'Assignment history',
  'Vozidlo zatiaľ nebolo nikomu pridelené': 'The car has not been assigned to anyone yet',
  'Servisná história': 'Service history',
  'Náklady spolu: {cost}': 'Total costs: {cost}',
  'Nový záznam': 'New record',
  'Žiadne servisné záznamy': 'No service records',
  'Zmazať servisný záznam': 'Delete service record',
  'Naozaj zmazať záznam zo dňa {serviceDate}?': 'Really delete the record from {serviceDate}?',
  'Záznam bol zmazaný': 'The record was deleted',
  'Žiadne dokumenty': 'No documents',
  'GPS – mesačné záznamy': 'GPS – monthly records',
  'Import knihy jázd': 'Import logbook',
  'Žiadne importované mesiace': 'No imported months',
  'V evidencii (bez vyradených)': 'In the register (without retired)',
  'Rok': 'Year',
  'Upraviť {plate}': 'Edit {plate}',
  'Evidencia vozového parku': 'Fleet register',
  'Hľadať ŠPZ, značku, model, VIN…': 'Search plate, make, model, VIN…',
  'Všetky stavy': 'All statuses',
  'Žiadne vozidlá nezodpovedajú filtru': 'No cars match the filter',
  'Vozidlo vrátené': 'Car returned',
  'Pripravená': 'Prepared',
  'Ukončená': 'Ended',
  'Prebieha': 'In progress',
  'Číslo': 'Number',
  'Obdobie': 'Period',
  '{rate} / deň': '{rate} / day',
  'Vystavil': 'Issued by',
  'Stiahnuť (Word)': 'Download (Word)',
  'Zmluva {number} bola zmazaná': 'Contract {number} was deleted',
  'Zmluvy o nájme vozidiel – vygenerovaním zmluvy sa vozidlo zároveň pridelí pracovníkovi': 'Car rental contracts – generating a contract also assigns the car to the worker',
  'Číslo zmluvy, meno, ŠPZ…': 'Contract number, name, plate…',
  'Všetci pracovníci': 'All workers',
  'Žiadne zmluvy nezodpovedajú filtru': 'No contracts match the filter',
  'Zmazať zmluvu': 'Delete contract',
  'Zmluva {number} ({driver}) a jej dokument budú zmazané. Ak vozidlo ešte nebolo vrátené, zruší sa aj pridelenie vytvorené touto zmluvou. Záznam zostane v audit logu.': 'Contract {number} ({driver}) and its document will be deleted. If the car has not been returned yet, the assignment created by this contract is cancelled too. The record stays in the audit log.',
  'Stav vozového parku a úlohy vyžadujúce pozornosť': 'Fleet status and tasks needing attention',
  'Vozidlá v evidencii': 'Cars in the register',
  'Aktívne vozidlá': 'Active cars',
  'V servise': 'In service',
  'Aktívni vodiči': 'Active drivers',
  'Požičané vozidlá': 'Cars on loan',
  'Servisy do 30 dní': 'Services within 30 days',
  'Končiace dokumenty': 'Expiring documents',
  'Končiace vodičáky': 'Expiring driving licences',
  'Známky končiace do 30 dní': 'Vignettes expiring within 30 days',
  'Nezaplatené pokuty': 'Unpaid fines',
  'Máte {alerts} upozornení na blížiace sa termíny (servisy, platnosť dokumentov, vodičských preukazov alebo diaľničných známok).': 'You have {alerts} alerts about upcoming deadlines (services, validity of documents, driving licences or motorway vignettes).',
  'Plánované servisy': 'Planned services',
  'Po termíne alebo do 30 dní / 1 500 km': 'Overdue or within 30 days / 1,500 km',
  'Žiadne blížiace sa servisy': 'No upcoming services',
  'Po termíne': 'Overdue',
  'o {daysLeft} dní': 'in {daysLeft} days',
  'zostáva {kmLeft} km': '{kmLeft} km left',
  'Končiaca platnosť dokumentov': 'Expiring documents',
  'Neplatné alebo končiace do 30 dní': 'Expired or expiring within 30 days',
  'Žiadne končiace dokumenty': 'No expiring documents',
  'neplatné od {expiryDate}': 'expired on {expiryDate}',
  'Posledné zmeny': 'Recent changes',
  'Zatiaľ žiadna aktivita': 'No activity yet',
  'systém': 'system',
  'Poistky, technické preukazy, protokoly a ďalšie súbory k vozidlám': 'Insurance policies, registration certificates, protocols and other files for the cars',
  'Názov, súbor, poznámka…': 'Title, file, note…',
  'Všetky typy': 'All types',
  'Platnosť': 'Validity',
  'Ľubovoľná': 'Any',
  'Neplatné alebo končia do 30 dní': 'Expired or expiring within 30 days',
  'Končia do 30 dní': 'Expiring within 30 days',
  'Neplatné': 'Expired',
  'Žiadne dokumenty nezodpovedajú filtru': 'No documents match the filter',
  'os. č. {employeeId}': 'emp. no. {employeeId}',
  'Kontakt': 'Contact',
  'Vodičský preukaz': 'Driving licence',
  'Aktívny': 'Active',
  'Neaktívny': 'Inactive',
  'Deaktivovať': 'Deactivate',
  'Aktivovať': 'Activate',
  'Vodič bol deaktivovaný': 'The driver was deactivated',
  'Vodič bol aktivovaný': 'The driver was activated',
  'Zamestnanci oprávnení viesť služobné vozidlá': 'Employees allowed to drive company cars',
  'Hľadať meno, os. číslo, oddelenie…': 'Search name, employee number, department…',
  'Aktívni': 'Active',
  'Neaktívni': 'Inactive',
  'Ľubovoľná platnosť VP': 'Any licence validity',
  'VP neplatný / končí do 30 dní': 'Licence expired / expiring within 30 days',
  'Žiadni vodiči nezodpovedajú filtru': 'No drivers match the filter',
  'Deaktivovať vodiča': 'Deactivate driver',
  'Aktivovať vodiča': 'Activate driver',
  'Vodič {firstName} {lastName} nebude ponúkaný pri prideľovaní vozidiel. História zostane zachovaná.': 'Driver {firstName} {lastName} will not be offered when assigning cars. The history is kept.',
  'Vodič {firstName} {lastName} bude opäť dostupný na prideľovanie vozidiel.': 'Driver {firstName} {lastName} will be available for car assignments again.',
  'Kto, kde a za koľko – prehľad nákladov na pokuty': 'Who, where and how much – overview of fine costs',
  'Všetky roky': 'All years',
  'Pridať pokutu': 'Add fine',
  'Pokuty spolu {year}': 'Total fines {year}',
  'Pokuty spolu': 'Total fines',
  '{count} pokút': '{count} fines',
  'Zaplatila firma': 'Paid by the company',
  'Zaplatil vodič': 'Paid by the driver',
  'Nezaplatené': 'Unpaid',
  '{unpaidCount} pokút čaká na úhradu': '{unpaidCount} fines awaiting payment',
  'všetko uhradené': 'all paid',
  'Pokuty podľa mesiacov {year}': 'Fines by month {year}',
  'Suma v € podľa dátumu priestupku': 'Amount in € by date of offence',
  'Podľa krajiny': 'By country',
  'Podľa osoby': 'By person',
  'Podľa vozidla': 'By car',
  'Ostatné ({rest})': 'Other ({rest})',
  'bez pokút': 'no fines',
  'Pokuta je označená ako zaplatená': 'The fine is marked as paid',
  'Kto': 'Who',
  'neurčený': 'unknown',
  'Priestupok': 'Offence',
  'č. {reference}': 'no. {reference}',
  'Suma': 'Amount',
  'Úhrada': 'Payment',
  'Zaplatené {paidDate}': 'Paid {paidDate}',
  'Zaplatené': 'Paid',
  'vodič': 'driver',
  'firma': 'company',
  'Označiť ako zaplatenú (firma)': 'Mark as paid (company)',
  'Označiť ako zaplatenú': 'Mark as paid',
  'Meno, priestupok, číslo…': 'Name, offence, number…',
  'Všetky krajiny': 'All countries',
  '{count} pokút · spolu {sum}': '{count} fines · total {sum}',
  'Žiadne pokuty nezodpovedajú filtru': 'No fines match the filter',
  'Zmazať pokutu': 'Delete fine',
  'Zmazať pokutu {amount} ({country}, {fineDate})?': 'Delete the fine {amount} ({country}, {fineDate})?',
  'Pokuta bola zmazaná': 'The fine was deleted',
  'Nastavte si vlastné heslo': 'Set your own password',
  'Účet {username} má dočasné heslo. Pred pokračovaním si zvoľte nové heslo, ktoré poznáte iba vy.': 'Account {username} has a temporary password. Before continuing, choose a new password that only you know.',
  'Dočasné heslo': 'Temporary password',
  'Zadajte dočasné heslo': 'Enter the temporary password',
  'Nové heslo musí byť iné ako dočasné': 'The new password must differ from the temporary one',
  'Uložiť heslo a pokračovať': 'Save password and continue',
  'Dátum jazdy': 'Ride date',
  'ŠPZ vozidla': 'Licence plate',
  'Čas začiatku': 'Start time',
  'Čas konca': 'End time',
  'Odkiaľ': 'From',
  'Kam': 'To',
  'Vzdialenosť (km)': 'Distance (km)',
  'Doba jazdy (min)': 'Ride duration (min)',
  'Vodič (meno)': 'Driver (name)',
  'Účel jazdy': 'Ride purpose',
  'Číslo jazdy': 'Ride number',
  'GPSPOLOHA.SK – kniha jázd': 'GPSPOLOHA.SK – logbook',
  'Všeobecná tabuľka': 'General table',
  'Nerozpoznaný': 'Not recognised',
  'Mesačné knihy jázd z GPS systému – jeden záznam za vozidlo a mesiac': 'Monthly logbooks from the GPS system – one record per car and month',
  'Mesačné záznamy': 'Monthly records',
  'Nový import': 'New import',
  'Súbory sa nepodarilo spracovať': 'The files could not be processed',
  '{rejected} súbor(ov) nie je vo formáte XLSX': '{rejected} file(s) are not in XLSX format',
  'Importované mesačné záznamy: {months}': 'Imported monthly records: {months}',
  'Nebol importovaný žiadny mesačný záznam': 'No monthly record was imported',
  'Import zlyhal': 'Import failed',
  'Import dokončený': 'Import completed',
  'Súbory: {count}': 'Files: {count}',
  'Z toho nahradené': 'Of which replaced',
  'Importované jazdy': 'Imported rides',
  'Chybné riadky': 'Faulty rows',
  'Novo založené vozidlá (doplňte značku a model): {cars}': 'Newly created cars (fill in make and model): {cars}',
  'Novo založení vodiči: {drivers}': 'Newly created drivers: {drivers}',
  'Stav km aktualizovaný podľa tachometra: {cars}': 'Mileage updated from the odometer: {cars}',
  'Importovať ďalšie súbory': 'Import more files',
  'Zobraziť mesačné záznamy': 'Show monthly records',
  'Pridať ďalšie súbory (pretiahnite sem alebo kliknite)': 'Add more files (drag here or click)',
  'Pretiahnite sem mesačné knihy jázd (XLSX) alebo kliknite pre výber': 'Drag monthly logbooks (XLSX) here or click to choose',
  'Export „mesačná kniha jázd“ z GPSPOLOHA.SK (súbor KJ_…) – jeden súbor za vozidlo a mesiac, vozidlo sa rozpozná z hlavičky. Naraz môžete nahrať viac vozidiel aj mesiacov. Z každého vznikne jeden mesačný záznam s kilometrami a navštívenými miestami; opätovný import toho istého mesiaca ho nahradí. Pred importom uvidíte náhľad; nič sa neuloží, kým import nepotvrdíte.': 'Export of the “monthly logbook” from GPSPOLOHA.SK (KJ_… file) – one file per car and month; the car is recognised from the header. You can upload several cars and months at once. Each becomes one monthly record with kilometres and places visited; importing the same month again replaces it. You will see a preview before importing; nothing is saved until you confirm the import.',
  '1. Súbory': '1. Files',
  '{files} súbor(ov) · {months} mesačných záznamov · {totalRows} jázd': '{files} file(s) · {months} monthly records · {totalRows} rides',
  'Spracovávam…': 'Processing…',
  'Začať znova': 'Start again',
  '{rows} jázd': '{rows} rides',
  'Mapovanie stĺpcov': 'Column mapping',
  'Pre súbory vo formáte bežnej tabuľky. Stĺpce sa rozpoznali automaticky – skontrolujte ich.': 'For files in a general table format. The columns were recognised automatically – please check them.',
  '— nepoužiť —': '— do not use —',
  'Aktualizovať náhľad': 'Update preview',
  'Chýbajú povinné stĺpce: {columns}': 'Required columns missing: {columns}',
  '2. Kontrola údajov': '2. Data check',
  'Nahradia existujúce': 'Will replace existing',
  'Jázd na import': 'Rides to import',
  'V súboroch sú vozidlá alebo vodiči, ktorí ešte nie sú v evidencii': 'The files contain cars or drivers that are not in the register yet',
  'Vozidlá: {cars}': 'Cars: {cars}',
  'Vodiči: {drivers}': 'Drivers: {drivers}',
  'Automaticky ich založiť (inak sa ich jazdy preskočia)': 'Create them automatically (otherwise their rides are skipped)',
  'V súboroch sa nenašli žiadne jazdy': 'No rides were found in the files',
  'Mesiace označené „nahradí“ už v evidencii sú – ich doterajšie jazdy sa nahradia jazdami z nahraného súboru.': 'Months marked “replaces” are already in the register – their current rides will be replaced by the rides from the uploaded file.',
  'Jazdy v súboroch ({count})': 'Rides in the files ({count})',
  'Zobrazených prvých {shown} z {total} jázd.': 'Showing the first {shown} of {total} rides.',
  'Importuje sa {months} mesačných záznamov ({rides} jázd)': '{months} monthly records will be imported ({rides} rides)',
  ' bez neznámych vozidiel': ' without unknown cars',
  'Potvrdiť import': 'Confirm import',
  'Jázd': 'Rides',
  'nahradí existujúci': 'replaces existing',
  'nový': 'new',
  'nové vozidlo': 'new car',
  'Nahradené': 'Replaced',
  'Nové': 'New',
  'Súbor / riadok': 'File / row',
  'Riadok': 'Row',
  'nové': 'new',
  'OK': 'OK',
  '{count} mesačných záznamov · spolu {sum}': '{count} monthly records · total {sum}',
  'Žiadne mesačné záznamy': 'No monthly records',
  'Nahrajte mesačnú knihu jázd v záložke „Nový import“.': 'Upload a monthly logbook in the “New import” tab.',
  'Zmazať mesačný záznam': 'Delete monthly record',
  'Zmazať záznam {plate} za {month} so všetkými {rideCount} jazdami? Mesiac potom môžete importovať znova.': 'Delete the record {plate} for {month} with all {rideCount} rides? You can import the month again afterwards.',
  'Zmazaný mesačný záznam ({deleted} jázd)': 'Monthly record deleted ({deleted} rides)',
  'Mesačný záznam sa nenašiel': 'Monthly record not found',
  '{brand} {model} · mesačná kniha jázd': '{brand} {model} · monthly logbook',
  'Najazdené km': 'Km driven',
  'Služobne km': 'Business km',
  'Súkromne km': 'Private km',
  'Čas jazdy': 'Driving time',
  'Importované': 'Imported',
  'Navštívené miesta (od najčastejších)': 'Places visited (most frequent first)',
  'Jazdy v mesiaci': 'Rides in the month',
  'Žiadne jazdy': 'No rides',
  'Prihlásenie sa nepodarilo': 'Sign-in failed',
  'Prihlásenie': 'Sign in',
  'Interný systém evidencie vozového parku': 'Internal fleet management system',
  'Zadajte používateľské meno': 'Enter your username',
  'Heslo': 'Password',
  'Zadajte heslo': 'Enter your password',
  'Prihlásiť sa': 'Sign in',
  'V poriadku': 'OK',
  'Blíži sa': 'Approaching',
  'Čoskoro': 'Soon',
  '{daysLeft} dní po termíne': '{daysLeft} days overdue',
  'prekročené o {kmLeft} km': 'exceeded by {kmLeft} km',
  'bez plánu – zadať servis': 'no plan – record a service',
  '{title}: {label}. Posledný {lastDate}, ďalší {next}. {remaining}': '{title}: {label}. Last {lastDate}, next {next}. {remaining}',
  '{title}: {label}': '{title}: {label}',
  'ďalší: {next}': 'next: {next}',
  'Ako ďaleko je každé vozidlo od servisu a od STK / EK – podľa dátumu alebo kilometrov, čo nastane skôr': 'How far each car is from its service and its MOT (STK / EK) – by date or kilometres, whichever comes first',
  'Zapísať servis': 'Record service',
  'Bez plánu': 'No plan',
  'Žiadne vozidlá v prevádzke': 'No cars in service',
  'STK / EK': 'MOT (STK / EK)',
  'Pás ukazuje, koľko z intervalu od posledného servisu už uplynulo. Červená = do 30 dní alebo 1 500 km, príp. po termíne; oranžová = viac ako 75 % intervalu. Plán sa berie z posledného servisného záznamu s vyplneným „ďalší servis“ (STK / EK z typu „Kontrola / STK / EK“).': 'The bar shows how much of the interval since the last service has passed. Red = within 30 days or 1,500 km, or overdue; orange = more than 75 % of the interval. The plan is taken from the latest service record with “next service” filled in (MOT from the type “Inspection / STK / EK”).',
  'Stránka sa nenašla': 'Page not found',
  'Požadovaná stránka neexistuje.': 'The requested page does not exist.',
  'Späť na prehľad': 'Back to the overview',
  'Rezervácie vozidiel': 'Car reservations',
  'Kalendár voľných, rezervovaných a požičaných vozidiel': 'Calendar of free, reserved and lent-out cars',
  'Zrušiť rezerváciu': 'Cancel reservation',
  'Zrušiť rezerváciu {plate} pre {person} ({dateFrom} – {dateTo})?': 'Cancel the reservation of {plate} for {person} ({dateFrom} – {dateTo})?',
  ' Vozidlo už bolo odovzdané – pridelenie zostane, ukončite ho v Pridelení.': ' The car has already been handed over – the assignment stays; end it in Assignments.',
  'Rezervácia bola zrušená': 'The reservation was cancelled',
  'Presun bol vrátený – {message}': 'Move undone – {message}',
  'Rezervácia presunutá – {message}': 'Reservation moved – {message}',
  'Späť': 'Undo',
  'Rezerváciu sa nepodarilo presunúť': 'The reservation could not be moved',
  'Rezerváciu nemožno presunúť do minulosti': 'A reservation cannot be moved into the past',
  'Vozidlo je v tomto období už rezervované pre {label}': 'The car is already reserved for {label} in this period',
  'Rezervované': 'Reserved',
  'bez plánovaného konca': 'no planned end',
  'Predchádzajúci mesiac': 'Previous month',
  'Nasledujúci mesiac': 'Next month',
  'Dnes': 'Today',
  'voľné': 'free',
  'rezervované': 'reserved',
  'požičané': 'on loan',
  '{plate}, {day}: voľné – kliknutím rezervujete': '{plate}, {day}: free – click to reserve',
  ' – potiahnutím presuniete, za okraj zmeníte dĺžku': ' – drag to move, drag an edge to change the length',
  'Žiadne aktívne vozidlá': 'No active cars',
  'Kliknite na voľný deň pre novú rezerváciu, na rezervovaný pre úpravu. Rezerváciu môžete myšou potiahnuť na iné dni, potiahnutím okraja zmeníte jej dĺžku (ukončené rezervácie sa presunúť nedajú). Požičané = odovzdané so zmluvou alebo interne (Pridelenie).': 'Click a free day for a new reservation, a reserved one to edit it. You can drag a reservation to other days with the mouse, or drag its edge to change its length (ended reservations cannot be moved). On loan = handed over with a contract or internally (Assignments).',
  'mimo zoznamu pracovníkov': 'not on the worker list',
  'Odovzdané · zmluva {number}': 'Handed over · contract {number}',
  'Odovzdané interne': 'Handed over internally',
  'Odovzdať': 'Hand over',
  'Aktuálne a nadchádzajúce rezervácie': 'Current and upcoming reservations',
  'Žiadne nadchádzajúce rezervácie': 'No upcoming reservations',
  '{person} bol(a) pridaný(á) do zoznamu vodičov': '{person} was added to the list of drivers',
  'Vozidlo {plate} bolo interne požičané – {person}': 'Car {plate} was lent internally – {person}',
  'Vozidlo sa nepodarilo odovzdať': 'The car could not be handed over',
  'Odovzdať vozidlo': 'Hand over the car',
  'So zmluvou o nájme': 'With a rental contract',
  'Pre živnostníka alebo externú osobu. Otvorí sa predvyplnená zmluva (Word) a vozidlo sa pridelí.': 'For a self-employed worker or an external person. A pre-filled contract (Word) opens and the car is assigned.',
  'Interne, bez zmluvy': 'Internally, without a contract',
  'Zamestnanec firmy – vozidlo sa iba pridelí na rezervované obdobie (Pridelenie).': 'Company employee – the car is just assigned for the reserved period (Assignments).',
  'Termín': 'Due date',
  'Pri stave km': 'At mileage',
  'Servisy a údržba': 'Services and maintenance',
  'Servisné záznamy, náklady a plánovaná údržba': 'Service records, costs and planned maintenance',
  'Servisné záznamy': 'Service records',
  'Plánovaná údržba': 'Planned maintenance',
  'Vozidlá, ktorých posledný servisný záznam plánuje ďalšiu údržbu do 30 dní alebo do 1 500 km (prípadne už po termíne).': 'Cars whose latest service record plans the next maintenance within 30 days or 1,500 km (or already overdue).',
  'Žiadna blížiaca sa údržba': 'No upcoming maintenance',
  'Popis, servis, faktúra…': 'Description, workshop, invoice…',
  'Náklady za vybrané záznamy: {sum}': 'Costs of the selected records: {sum}',
  'Naozaj zmazať servisný záznam {plate} zo dňa {serviceDate}?': 'Really delete the service record of {plate} from {serviceDate}?',
  'Používateľské účty a vzhľad aplikácie': 'User accounts and app appearance',
  'Používatelia': 'Users',
  'Vzhľad a firma': 'Appearance and company',
  'Deaktivovaný': 'Deactivated',
  'Vytvorený': 'Created',
  'Administrátor vidí audit log a spravuje používateľov aj vzhľad. Bežný používateľ spravuje vozidlá, vodičov, servisy, dokumenty a importy.': 'An administrator sees the audit log and manages users and the appearance. A regular user manages cars, drivers, services, documents and imports.',
  'Nový používateľ': 'New user',
  'Deaktivovať používateľa': 'Deactivate user',
  'Aktivovať používateľa': 'Activate user',
  'Používateľ {username} sa nebude môcť prihlásiť. Jeho záznamy v audit logu zostanú zachované.': 'User {username} will not be able to sign in. Their audit log entries are kept.',
  'Používateľ {username} sa bude opäť môcť prihlásiť.': 'User {username} will be able to sign in again.',
  'Používateľ uložený, heslo bolo zmenené': 'User saved, the password was changed',
  'Používateľ uložený': 'User saved',
  'Používateľ bol vytvorený': 'The user was created',
  'Používateľa sa nepodarilo uložiť': 'The user could not be saved',
  'Upraviť používateľa {username}': 'Edit user {username}',
  'Aspoň 3 znaky': 'At least 3 characters',
  'Iba písmená bez diakritiky, číslice, . _ -': 'Only letters without accents, digits, . _ -',
  'Vlastnú rolu nie je možné zmeniť': 'You cannot change your own role',
  'Vyplňte iba pri nastavení nového hesla (používateľ si ho pri prihlásení zmení)': 'Fill in only to set a new password (the user changes it when signing in)',
  'Účet je aktívny': 'The account is active',
  'Vyberte obrázok (PNG, SVG, JPG)': 'Choose an image (PNG, SVG, JPG)',
  'Logo môže mať najviac 500 kB': 'The logo can be at most 500 kB',
  'Nastavenie vzhľadu bolo uložené': 'The appearance settings were saved',
  'Firma a vzhľad': 'Company and appearance',
  'Zobrazuje sa na prihlasovacej stránke, v menu a v titulku okna': 'Shown on the sign-in page, in the menu and in the window title',
  'Názov spoločnosti / aplikácie': 'Company / app name',
  'Hex kód farby': 'Hex colour code',
  'Bez loga': 'No logo',
  'Vybrať obrázok': 'Choose image',
  'Odobrať': 'Remove',
  'PNG alebo SVG s priehľadným pozadím, max. 500 kB.': 'PNG or SVG with a transparent background, max. 500 kB.',
  'Uložiť nastavenie': 'Save settings',
  'Náhľad tlačidiel': 'Button preview',
  'Hlavná akcia': 'Main action',
  'Vedľajšia akcia': 'Secondary action',
  'Zvýraznená položka menu': 'Highlighted menu item',
  'Aké pneumatiky má ktoré vozidlo práve namontované': 'Which tyres each car currently has fitted',
  'Zimné obdobie: {count} vozidlo má letné pneumatiky. Pri snehu alebo ľade sú na Slovensku povinné zimné.': 'Winter period: {count} car has summer tyres. Winter tyres are mandatory in Slovakia in snow or ice.',
  'Zimné obdobie: {count} vozidlá majú letné pneumatiky. Pri snehu alebo ľade sú na Slovensku povinné zimné.': 'Winter period: {count} cars have summer tyres. Winter tyres are mandatory in Slovakia in snow or ice.',
  'Žiadne vozidlá': 'No cars',
  'Upraviť pneumatiky': 'Edit tyres',
  'Upraviť pneumatiky {plate}': 'Edit tyres of {plate}',
  'Značka nezadaná': 'Make not entered',
  'namontované {date}': 'fitted {date}',
  'Zadať pneumatiky': 'Enter tyres',
  'letné v zimnom období': 'summer tyres in winter',
  'Oficiálny predaj známok – {shopName}': 'Official vignette shop – {shopName}',
  'Kúpiť': 'Buy',
  'Elektronické známky v krajinách EÚ, kde sú pre osobné autá povinné': 'Electronic vignettes in EU countries where they are mandatory for passenger cars',
  'Pridať známku': 'Add vignette',
  'Prehľad vozidiel': 'Cars overview',
  'Všetky známky': 'All vignettes',
  '{name}: platná do {validTo} – pridať ďalšiu': '{name}: valid until {validTo} – add another',
  'Pridať známku – {name}': 'Add vignette – {name}',
  '{name}: {validFrom} – {validTo}. Kliknutím pridáte ďalšiu.': '{name}: {validFrom} – {validTo}. Click to add another.',
  'neplatná': 'expired',
  'o {days} dní': 'in {days} days',
  'platná': 'valid',
  'končí do {WARNDAYS} dní': 'ends within {WARNDAYS} days',
  'Kliknutím na políčko pridáte známku (obnovenie začne dňom po skončení aktuálnej). „Kúpiť“ otvorí oficiálny štátny e-shop.': 'Click a cell to add a vignette (a renewal starts the day after the current one ends). “Buy” opens the official state e-shop.',
  'Doklad': 'Receipt',
  'Platné dnes': 'Valid today',
  'Končia do {WARNDAYS} dní': 'Ending within {WARNDAYS} days',
  '{count} známok · spolu {sum}': '{count} vignettes · total {sum}',
  'Žiadne známky nezodpovedajú filtru': 'No vignettes match the filter',
  'Zmazať známku': 'Delete vignette',
  'Zmazať známku {country} pre {plate} ({validFrom} – {validTo})?': 'Delete the {country} vignette for {plate} ({validFrom} – {validTo})?',
  'Známka bola zmazaná': 'The vignette was deleted',
  'Predané': 'Sold',
  'Vyradené': 'Retired',
  'Benzín': 'Petrol',
  'Nafta': 'Diesel',
  'Elektro': 'Electric',
  'Hybrid': 'Hybrid',
  'Údržba': 'Maintenance',
  'Oprava': 'Repair',
  'Kontrola / STK / EK': 'Inspection / MOT (STK / EK)',
  'Ostatné': 'Other',
  'Odovzdávací protokol': 'Handover protocol',
  'Poistenie': 'Insurance',
  'Technický preukaz': 'Registration certificate',
  'Fotografie': 'Photos',
  'Zamestnanec': 'Employee',
  'Živnostník': 'Self-employed',
  'Letné': 'Summer',
  'L': 'S',
  'Zimné': 'Winter',
  'Z': 'W',
  'Celoročné': 'All-season',
  'C': 'A',
  'Slovensko': 'Slovakia',
  'Česko': 'Czechia',
  'Rakúsko': 'Austria',
  'Maďarsko': 'Hungary',
  'Poľsko': 'Poland',
  'Nemecko': 'Germany',
  'Slovinsko': 'Slovenia',
  'Chorvátsko': 'Croatia',
  'Taliansko': 'Italy',
  'Francúzsko': 'France',
  'Švajčiarsko': 'Switzerland',
  'Belgicko': 'Belgium',
  'Holandsko': 'Netherlands',
  'Luxembursko': 'Luxembourg',
  'Dánsko': 'Denmark',
  'Švédsko': 'Sweden',
  'Nórsko': 'Norway',
  'Fínsko': 'Finland',
  'Španielsko': 'Spain',
  'Portugalsko': 'Portugal',
  'Rumunsko': 'Romania',
  'Bulharsko': 'Bulgaria',
  'Srbsko': 'Serbia',
  'Grécko': 'Greece',
  'Litva': 'Lithuania',
  'Lotyšsko': 'Latvia',
  'Estónsko': 'Estonia',
  'Írsko': 'Ireland',
  'Spojené kráľovstvo': 'United Kingdom',
  'Ukrajina': 'Ukraine',
  '1-dňová': '1-day',
  'víkendová': 'weekend',
  '7-dňová / týždenná': '7-day / weekly',
  '10-dňová': '10-day',
  'mesačná / 30-dňová': 'monthly / 30-day',
  '2-mesačná': '2-month',
  'štvrťročná / 90-dňová': 'quarterly / 90-day',
  'ročná': 'annual',
  'regionálna (župná) ročná': 'regional (county) annual',
  'Pridelenia': 'Assignments',
  'Vytvorenie': 'Creation',
  'Zmazanie': 'Deletion',
  'Neúspešné prihlásenie': 'Failed sign-in',
  'Import': 'Import',
  'Spolu za {days} dni: {total} bez DPH': 'Total for {days} days: {total} excl. VAT',
  'Spolu za {days} dní: {total} bez DPH': 'Total for {days} days: {total} excl. VAT',
  'Domov': 'Home',
  'Prepnúť na štandardné zobrazenie': 'Switch to standard view',
  'Prepnúť na zobrazenie s dlaždicami': 'Switch to tile view',
  'Náklady': 'Costs',
  'Kategória': 'Category',
  'Priemer na vozidlo': 'Average per car',
  'Vitajte, {name}': 'Welcome, {name}',
  'Vyberte, s čím chcete pracovať': 'Choose what you want to work on',
  'Opravy': 'Repairs',
  'Celkové náklady vozového parku a náklady jednotlivých vozidiel': 'Total fleet costs and the costs of each car',
  'Pripravujeme:': 'Coming soon:',
  'Spolu': 'Total',
  'Najviac opráv': 'Most repairs',
  '{count}×': '{count}×',
  'Údržba, STK, pneu': 'Maintenance, MOT, tyres',
  'Známky': 'Vignettes',
  '€ / km': '€ / km',
  'Najvyšší náklad na km': 'Highest cost per km',
  'Spotreba': 'Consumption',
  'Náklady spolu {year}': 'Total costs {year}',
  'Náklady spolu': 'Total costs',
  '{count} položiek': '{count} items',
  '{count} opráv': '{count} repairs',
  '{count} vozidiel s nákladmi': '{count} cars with costs',
  '{count} opráv, {amount}': '{count} repairs, {amount}',
  'žiadne opravy': 'no repairs',
  'Náklady podľa mesiacov {year}': 'Costs by month {year}',
  'Podľa kategórií': 'By category',
  'Porovnanie vozidiel': 'Car comparison',
  'Kliknite na vozidlo pre detail jeho nákladov': 'Click a car to see its costs in detail',
  'Detail': 'Detail',
  'Karta vozidla': 'Car card',
  'priemer vozidla vo vozovom parku {amount}': 'fleet average per car {amount}',
  'podľa GPS kníh jázd': 'from GPS trip logs',
  'Náklad na km': 'Cost per km',
  'priemer vozového parku {value} €': 'fleet average {value} €',
  'Položky nákladov': 'Cost items',
  'Žiadne náklady v tomto období': 'No costs in this period',
  'Posledná poloha (GPS)': 'Last position (GPS)',
  'Stiahnuté z GPS – vozidlá: {cars}, jazdy: {rides}': 'Downloaded from GPS – vehicles: {cars}, trips: {rides}',
  'Sťahovanie z GPS zlyhalo': 'GPS download failed',
  ' a ': ' and ',
  'Automatické sťahovanie z GPSPOLOHA': 'Automatic download from GPSPOLOHA',
  'Každý deň o {hours} sa stiahnu jazdy, kilometre a poloha všetkých vozidiel.': 'Every day at {hours} the trips, kilometres and position of all vehicles are downloaded.',
  'Nie je zapnuté – na serveri chýba premenná GPSPOLOHA_API_KEY.': 'Not enabled – the GPSPOLOHA_API_KEY variable is missing on the server.',
  'Stiahnuť teraz': 'Download now',
  'Naposledy:': 'Last run:',
  'ručne': 'manually',
  'automaticky': 'automatically',
  'aktualizované vozidlá: {cars} z {total}, jazdy: {rides}': 'vehicles updated: {cars} of {total}, trips: {rides}',
  'Nie sú v GPSPOLOHA: {plates}': 'Not in GPSPOLOHA: {plates}',
  'Tankovanie bolo uložené': 'Refuelling saved',
  'Tankovanie bolo pridané': 'Refuelling added',
  'Tankovanie sa nepodarilo uložiť': 'The refuelling could not be saved',
  'Upraviť tankovanie': 'Edit refuelling',
  'Nové tankovanie': 'New refuelling',
  'Pre tankovanie zaplatené v hotovosti alebo inou kartou – tankovanie zo Shell kariet sa importuje.': 'For refuelling paid in cash or with another card – Shell card refuelling is imported.',
  'Produkt': 'Product',
  'Zadajte produkt': 'Enter the product',
  'Druh': 'Type',
  'Do spotreby sa počíta iba palivo': 'Only fuel counts toward consumption',
  'Množstvo (l)': 'Quantity (l)',
  'Platba': 'Payment',
  'Suma s DPH (€)': 'Amount incl. VAT (€)',
  'Sadzba DPH (%)': 'VAT rate (%)',
  'Bez DPH: {net} – táto suma ide do nákladov': 'Excl. VAT: {net} – this amount goes into costs',
  'Kto tankoval': 'Who refuelled',
  'Neurčený': 'Not specified',
  'Čerpacia stanica': 'Filling station',
  'napr. Shell Žilina': 'e.g. Shell Žilina',
  'Mesto': 'City',
  'AdBlue a nákupy na pumpe': 'AdBlue and station purchases',
  'Počítajú sa servisy a opravy s cenou, diaľničné známky, pokuty a tankovanie (palivo bez DPH).': 'Priced services and repairs, motorway vignettes, fines and refuelling (fuel excl. VAT) are counted.',
  'faktúry z doklado.sk.': 'invoices from doklado.sk.',
  'Palivo a spotreba': 'Fuel and consumption',
  'Tankovania vozidla': 'Vehicle\'s refuelling',
  'Palivo bez DPH': 'Fuel excl. VAT',
  'Natankované': 'Refuelled',
  'Priemerná spotreba': 'Average consumption',
  'Spotreba sa vypočíta pre mesiace, v ktorých sú tankovania aj GPS kilometre.': 'Consumption is calculated for months that have both refuelling and GPS kilometres.',
  '1. štvrťrok': 'Q1',
  '2. štvrťrok': 'Q2',
  '3. štvrťrok': 'Q3',
  '4. štvrťrok': 'Q4',
  'Tankovanie zo Shell kariet aj v hotovosti – náklady, litre a spotreba podľa GPS kilometrov': 'Refuelling with Shell cards and in cash – costs, litres and consumption by GPS kilometres',
  'Celý rok': 'Whole year',
  'Pridať tankovanie': 'Add refuelling',
  'Tankovania': 'Refuelling',
  'Import zo Shell karty': 'Shell card import',
  'V tomto období nie je žiadne tankovanie': 'No refuelling in this period',
  'Importujte export transakcií zo Shell karty alebo pridajte tankovanie ručne.': 'Import the Shell card transaction export or add refuelling by hand.',
  'Priem. cena / l': 'Avg. price / l',
  'Km podľa GPS': 'Km by GPS',
  'Najvyššia spotreba': 'Highest consumption',
  'Palivo € / km': 'Fuel € / km',
  'AdBlue a iné': 'AdBlue and other',
  'Upozornenia': 'Warnings',
  'Tankovanie iného paliva, než má vozidlo zapísané': 'Refuelled with a different fuel than recorded for the vehicle',
  '{count}× iné palivo': '{count}× other fuel',
  's DPH spolu {amount}': 'incl. VAT {amount} in total',
  '{count} transakcií': '{count} transactions',
  'Priemerná cena': 'Average price',
  's DPH, ako na pumpe': 'incl. VAT, as at the pump',
  'chýbajú GPS kilometre': 'GPS kilometres are missing',
  'na 100 km podľa GPS': 'per 100 km by GPS',
  'AdBlue {amount}': 'AdBlue {amount}',
  'Spotreba = litre paliva ÷ GPS kilometre v mesiacoch, ktoré majú oboje. Kliknite na vozidlo pre jeho tankovania.': 'Consumption = litres of fuel ÷ GPS kilometres in months that have both. Click a vehicle to see its refuelling.',
  'Podľa mesiacov': 'By month',
  'Palivo bez DPH a natankované litre': 'Fuel excl. VAT and litres refuelled',
  'Neznáma': 'Unknown',
  'Podľa platby': 'By payment',
  'Vozidlo má zapísané iné palivo': 'The vehicle has a different fuel recorded',
  'iné palivo': 'other fuel',
  'Množstvo': 'Quantity',
  'Bez DPH': 'Excl. VAT',
  's DPH {amount}': 'incl. VAT {amount}',
  'Kde': 'Where',
  'faktúra {invoice}': 'invoice {invoice}',
  'zatiaľ nevyfakturované': 'not invoiced yet',
  'Produkt, stanica, meno, faktúra…': 'Product, station, name, invoice…',
  'Zdroj': 'Source',
  'Shell karta (import)': 'Shell card (import)',
  'Zadané ručne': 'Entered by hand',
  '{count} transakcií · palivo {liters} · bez DPH {net} · s DPH {gross}': '{count} transactions · fuel {liters} · excl. VAT {net} · incl. VAT {gross}',
  'Žiadne tankovanie nezodpovedá filtru': 'No refuelling matches the filter',
  'Zmazať tankovanie': 'Delete refuelling',
  'Zmazať transakciu {product} {amount} ({date})? Pri ďalšom importe toho istého obdobia sa znova pridá.': 'Delete the transaction {product} {amount} ({date})? It will be added again by the next import of the same period.',
  'Zmazať tankovanie {product} {amount} ({date})?': 'Delete the refuelling {product} {amount} ({date})?',
  'Tankovanie bolo zmazané': 'Refuelling deleted',
  '{rejected} súbor(ov) nie je vo formáte CSV ani XLSX': '{rejected} file(s) are neither CSV nor XLSX',
  'Import dokončený – nové: {created}, aktualizované: {updated}': 'Import finished – new: {created}, updated: {updated}',
  'Nové transakcie': 'New transactions',
  'Aktualizované': 'Updated',
  'Bez zmeny (už importované)': 'Unchanged (already imported)',
  'Preskočené': 'Skipped',
  'Preskočené – vozidlá nie sú v systéme: {plates}': 'Skipped – vehicles not in the system: {plates}',
  'Importovať ďalší súbor': 'Import another file',
  'Zobraziť prehľad': 'Show overview',
  'Pretiahnite sem export transakcií zo Shell karty (CSV alebo XLSX) alebo kliknite pre výber': 'Drag the Shell card transaction export (CSV or XLSX) here or click to choose',
  'Súbor „transactions-…“ z portálu Shell / Fleetcor, napr. za mesiac alebo štvrťrok. Obdobia sa môžu prekrývať – už importované transakcie sa nepridajú druhýkrát, iba sa aktualizujú (napr. keď sú medzičasom vyfakturované). Pred importom uvidíte náhľad.': 'The “transactions-…” file from the Shell / Fleetcor portal, e.g. for a month or a quarter. Periods may overlap – transactions already imported are not added twice, only updated (e.g. once they have been invoiced). You will see a preview before the import.',
  '{rows} riadkov': '{rows} rows',
  'Odobrať súbor': 'Remove file',
  'Náhľad importu': 'Import preview',
  'Obdobie {from} – {to}': 'Period {from} – {to}',
  'Transakcie': 'Transactions',
  'Už importované': 'Already imported',
  'Litre paliva': 'Litres of fuel',
  'Tieto ŠPZ nie sú v systéme: {plates}': 'These plates are not in the system: {plates}',
  'Založiť chýbajúce vozidlá (inak sa ich transakcie preskočia)': 'Create the missing vehicles (otherwise their transactions are skipped)',
  'Iné palivo, než má vozidlo zapísané ({count}×) – skontrolujte druh paliva vozidla': 'Different fuel than recorded for the vehicle ({count}×) – check the vehicle\'s fuel type',
  'Spolu bez DPH {amount}': 'Total excl. VAT {amount}',
  'Chyby ({count})': 'Errors ({count})',
  '{file}, riadok {row}: {errors}': '{file}, row {row}: {errors}',
  'AdBlue': 'AdBlue',
  'Ostatné (oleje, príslušenstvo, umývanie…)': 'Other (oils, accessories, car wash…)',
  'Palivová karta (Shell)': 'Fuel card (Shell)',
  'Hotovosť': 'Cash',
  'Súkromná karta': 'Private card',
  'Iná firemná karta / iné': 'Other company card / other',
  'Kombinovaná spotreba podľa TP (l/100 km)': 'Combined consumption per registration doc. (l/100 km)',
  'napr. 6,2': 'e.g. 6.2',
  'Z technického preukazu – porovnáva sa so skutočným tankovaním': 'From the vehicle registration document – compared with the actual refuelling',
  'Zadajte číslo od 0 do 50': 'Enter a number from 0 to 50',
  'Objem nádrže (l)': 'Tank capacity (l)',
  'napr. 50': 'e.g. 50',
  'Zadajte číslo od 0 do 500': 'Enter a number from 0 to 500',
  'Spotreba podľa TP': 'Official consumption',
  'nádrž {liters} l': 'tank {liters} l',
  'Hospodárna jazda': 'Economical driving',
  'Zvýšená spotreba': 'Increased consumption',
  'Agresívna jazda': 'Aggressive driving',
  'Oproti spotrebe podľa technického preukazu': 'Compared with the official consumption',
  'Štýl jazdy': 'Driving style',
  'chýbajú GPS km': 'GPS km missing',
  'bez spotreby podľa TP': 'no official consumption',
  '{count} nádrže': '{count} tanks',
  'Štýl jazdy podľa technického preukazu': 'Driving style vs. registration document',
  'Koľko sa natankovalo oproti tomu, koľko by auto podľa TP spotrebovalo na najazdené GPS kilometre. Do +15 % hospodárna jazda, do +30 % zvýšená spotreba, nad 30 % agresívna jazda.': 'How much was refuelled compared with what the car should use for the GPS kilometres according to its registration document. Up to +15 % economical, up to +30 % increased consumption, over 30 % aggressive driving.',
  'TP {value} l/100 km': 'official {value} l/100 km',
  'Očakávané podľa TP': 'Expected (official)',
  '{count}× tankovanie': '{count}× refuelled',
  'Reálna spotreba': 'Real consumption',
  'Zatiaľ nie je čo hodnotiť – vozidlá potrebujú spotrebu podľa TP, tankovania aj GPS kilometre v tom istom mesiaci.': 'Nothing to rate yet – vehicles need an official consumption, refuelling and GPS kilometres in the same month.',
  'Doplňte spotrebu podľa TP a objem nádrže v karte vozidla:': 'Add the official consumption and tank capacity on the vehicle card:',
};
